import { BaseEntityDto } from "@/core/common/entities/base-entity.dto";
import { DocumentationIssueTypeCategoryEnum } from "@altertec_gparn/lib";

export class DocumentationIssueTypeDto extends BaseEntityDto {
  name: string;

  category: DocumentationIssueTypeCategoryEnum;
}
